module.exports = __webpack_public_path__ + "media/images/homepage_image_2-b0900432c438dc1a18d7e92ea8451127.png";